"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_mobile_1 = require("antd-mobile");
var react_1 = __importDefault(require("react"));
var AcLi_1 = __importDefault(require("./AcLi"));
function AccordionMobile(props) {
    var list = props.list;
    return (react_1.default.createElement("div", { className: "accordion-mobile" },
        react_1.default.createElement(antd_mobile_1.Swiper, null, list.map(function (l, i) {
            return (react_1.default.createElement(antd_mobile_1.Swiper.Item, { key: "ac-swip-mobile-".concat(i) },
                react_1.default.createElement(AcLi_1.default, __assign({}, l, { isMobile: true }))));
        }))));
}
exports.default = AccordionMobile;
//# sourceMappingURL=AccordionMobile.js.map